<template>
	<div class="member-information">
		<div class="common-header-wrap">
			<mt-header :title="$t('member.edit_member_profile')" class="common-header">
				<mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
				<div class="delete" slot="right" @click="sendAuthCode = true; authType = 'account'">{{ $t('member.profile.delete_account') }}</div>
			</mt-header>
		</div>
		<div class="user-avatar">
			<img :src="user.member_avatar">
			<div class="upload-avatar">
				<input ref="file" accept="image/*" type="file" @change="uploadImage($event)">
				<mt-button class="upload-avatar-button" type="primary" @click="$refs.file.click()">{{
						$t('member.upload_avatar')
					}}
				</mt-button>
			</div>
		</div>
		<div class="mobile">
			{{ member_info.member_mobile }}
			<cube-button :outline="true" :primary="true" :inline="true" style="font-size: 0.8rem; color: #FA800A; position: absolute; margin: -8px 8px" @click="sendAuthCode = true; authType = 'mobile'">{{ $t('general.modify') }}</cube-button>
		</div>
		<div class="form">
			<!--  性別  -->
			<custom-mt-field :attr="{style: 'display:none'}" :hidden-state="true"
				:label="$t('member.profile.sex')" :validationParam="$v.member_info.member_sex"
				class="menu-item">
				<mt-radio v-model="$v.member_info.member_sex.$model" :options="sexOption"></mt-radio>
			</custom-mt-field>
			<!-- 姓氏 -->
			<custom-mt-field v-model.trim="$v.member_info.member_firstname.$model" :label="$t('member.profile.firstname')"
				:placeholder="$t('placeholder.firstname')"
				:validationParam="$v.member_info.member_firstname"
				class="menu-item"
			/>
			<!-- 名字 -->
			<custom-mt-field v-model.trim="$v.member_info.member_lastname.$model" :label="$t('member.profile.lastname')"
				:placeholder="$t('placeholder.lastname')"
				:validationParam="$v.member_info.member_lastname"
				class="menu-item"/>
			<!-- 暱稱 -->
			<custom-mt-field v-model.trim="$v.member_info.member_nickname.$model" :label="$t('member.profile.nickname')"
				:placeholder="$t('placeholder.nickname')"
				:validationParam="$v.member_info.member_nickname"
				class="menu-item"/>
			<!-- 信箱 -->
			<custom-mt-field v-model.trim="$v.member_info.member_email.$model" :label="$t('member.profile.email')"
				:placeholder="$t('placeholder.email')"
				:validationParam="$v.member_info.member_email"
				:isReadOnly="true"
				class="menu-item" type="email">
				<mt-button class="modify-password-button" type="primary" @click="showEmailForm = true">
					{{ $t('member.modify_email_short') }}
				</mt-button>
			</custom-mt-field>
			<!-- 信箱狀態 -->
			<mt-cell :title="$t('member.profile.email_bind_status')"
				class="menu-item">
				<mt-badge v-if="member_info.member_emailbind == 0" size="normal" type="error">{{ $t('member.profile.email_bind_status_none') }}</mt-badge>
				<mt-badge v-if="member_info.member_emailbind == 1" size="normal" color="#f4c41e">{{ $t('member.profile.email_bind_status_binded') }}</mt-badge>
				<mt-button v-if="member_info.member_emailbind == 0" class="modify-password-button" type="primary" @click="showEmailForm = true; bindEmail = true">
					{{ $t('member.bind_email') }}
				</mt-button>
			</mt-cell>
			<!-- 出生日期 -->
			<custom-mt-field
				:hidden-state="true"
				:label="$t('member.profile.birthday')"
				class="menu-item"
				v-model="member_info.member_birthday"
				readonly
				disableClear
			>
				<div @click="onTime" class="icon">
					<span class="iconfont icon-shijian"></span>
				</div>
			</custom-mt-field>

			<!-- 變更密碼 -->
			<custom-mt-field
				:hidden-state="true"
				:label="$t('member.profile.password')"
				readonly
				disableClear
			>
				<mt-button class="modify-password-button" type="primary" @click="displayPasswordForm('password')">
					{{ $t('member.modify_password') }}
				</mt-button>
			</custom-mt-field>
			<!-- 變更支付密碼 -->
			<custom-mt-field
				:hidden-state="true"
				:label="$t('member.profile.payment_password')"
				readonly
				disableClear
			>
				<mt-button class="modify-password-button" type="primary" @click="displayPasswordForm('payment_password')">
					{{ $t('member.modify_password') }}
				</mt-button>
			</custom-mt-field>

			<mt-button :disabled="$v.$invalid"  class="ds-button-large mt-10" size="large" type="primary" @click="submitInformation">
				{{ $t('general.save') }}
			</mt-button>
		</div>

		<mt-datetime-picker
			ref="timePicker"
			:cancel-text="$t('general.cancel')"
			:confirm-text="$t('general.confirm')"
			:endDate="new Date()"
			:startDate="new Date('1900/1/1')"
			:value="member_info.member_birthday?(new Date(member_info.member_birthday)):(new Date('1990/1/1'))"
			type="date"
			@confirm="timeConfirm"
		>
		</mt-datetime-picker>
		<mt-popup v-model="showCrop" class="crop-wrapper common-popup-wrapper" position="right">
			<div class="common-header-wrap">
				<mt-header class="common-header" title="裁剪图片">
					<mt-button slot="left" icon="back" @click="showCrop=false"></mt-button>
					<mt-button slot="right" @click="useCrop">使用</mt-button>
				</mt-header>
			</div>
			<vue-cropper ref="cropper" :autoCrop="cropperOption.autoCrop" :autoCropHeight="cropperOption.autoCropHeight"
				:autoCropWidth="cropperOption.autoCropWidth" :canMove="cropperOption.canMove"
				:img="cropperOption.img" :maxImgSize="cropperOption.maxImgSize"
				:outputType="cropperOption.outputType" class="common-popup-content"
				style="height: auto;position: absolute"></vue-cropper>
		</mt-popup>

		<mt-popup v-model="showPasswordForm" class="passwordPopup" popup-transition="popup-fade">
			<div style="font-size: 0.8rem; text-align: center; margin-bottom: 12px;">
				{{ passwordFormTitle }}
			</div>
			<password-form :type="passwordType" @updatePassword="showPasswordForm = false"></password-form>
		</mt-popup>

		<mt-popup v-model="sendAuthCode" position="right" class="common-popup-wrapper">
			<div class="common-header-wrap">
				<mt-header :title="$t('member.verify')" class="common-header">
					<mt-button slot="left" icon="back" @click="sendAuthCode = false"></mt-button>
				</mt-header>
			</div>
			<div class="common-popup-content">
				<common-send-code @checkSuccess="verifySuccess" />
			</div>
		</mt-popup>

		<!--修改手机-->
		<mt-popup v-model="showMobileForm" position="right" class="common-popup-wrapper">
			<div class="common-header-wrap">
				<mt-header :title="$t('member.modify_phone')" class="common-header">
					<mt-button slot="left" icon="back" @click="showMobileForm = false"></mt-button>
				</mt-header>
			</div>
			<div class="common-popup-content">
				<div class="mobile-popup-content">
					<flex-line class="field-line menu-item" :show-border="true">
						<span class="field-name">{{ $t('member.mobile_phone') }}</span>
						<div class="field-line-right" slot="right">
							<input class="field-input" v-model="newMobile" type="number" ref="newMobile" :attr="{ oninput: 'if(value.length>10)value=value.slice(0,10)' }" />
						</div>
					</flex-line>
					<flex-line class="field-line" :show-border="true">
						<span class="field-name">{{ $t('member.verify_code') }}</span>
						<div class="field-line-right" slot="right">
							<input class="field-input" v-model="verifyCode" type="number" :attr="{ oninput: 'if(value.length>6)value=value.slice(0,6)' }" />
							<div @click="sendVerifyCodeMobile" class="common-btn send-btn">{{sendStateTextMobile}}</div>
						</div>
					</flex-line>
					<div class="common-btn ds-button-large mt-10" @click='updateMobile' >{{ $t('general.enter') }}</div>
				</div>
			</div>
		</mt-popup>

		<!--修改信箱-->
		<mt-popup v-model="showEmailForm" position="right" class="common-popup-wrapper">
			<div class="common-header-wrap">
				<mt-header :title="bindEmail? $t('member.bind_email') : $t('member.modify_email')" class="common-header">
					<mt-button slot="left" icon="back" @click="showEmailForm = false; bindEmail = false"></mt-button>
				</mt-header>
			</div>
			<div class="common-popup-content">
				<div class="mobile-popup-content">
					<flex-line class="field-line menu-item" :show-border="true">
						<span class="field-name">{{ $t('member.profile.email') }}</span>
						<div class="field-line-right" slot="right">
							<input class="field-input" v-model="newEmail" type="string" ref="newEmail" :disabled="isNewEmailDiabled"/>
						</div>
					</flex-line>
					<flex-line class="field-line" :show-border="true">
						<span class="field-name">{{ $t('member.verify_code') }}</span>
						<div class="field-line-right" slot="right">
							<input class="field-input" v-model="verifyCode" type="number" :attr="{ oninput: 'if(value.length>6)value=value.slice(0,6)' }" />
							<div @click="sendVerifyCodeEmail" class="common-btn send-btn">{{sendStateTextEmail}}</div>
						</div>
					</flex-line>
					<div class="common-btn ds-button-large mt-10" @click='updateEmail' >{{ $t('general.enter') }}</div>
				</div>
			</div>
		</mt-popup>
	</div>
</template>

<script>
import { email, maxLength, required } from 'vuelidate/lib/validators'
import { VueCropper } from 'vue-cropper'
import { Indicator, Toast, MessageBox } from 'mint-ui'
import { mapMutations, mapState } from 'vuex'
import { updateMemberInfo, uploadMemberAvatar, deleteMember, logout } from '../../../api/member'
import { updateUserMobile, bindUserMobile } from '../../../api/memberSetting'
import { getEmailCode, checkEmailCode } from '@src/api/common'
import CustomMtField from '../../basic/CustomMtField'
import PasswordForm from './PasswordForm'
import CommonSendCode from '../common/CommonSendCode'
import flexLine from '../../flexLine'
import { VerifyCodeType } from '@src/const/member'

export default {
	components: {
		flexLine,
		CommonSendCode,
		VueCropper,
		CustomMtField,
		PasswordForm,
	},
	name: 'MemberProfileSet',
	data () {
		return {
			sendAuthCode: false,
			authType: 'mobile',
			showMobileForm: false,
			showEmailForm: false,
			newMobile: '',
			newEmail: '',
			isNewEmailDiabled: false,
			verifyCode: '',
			canSendMobile: true,
			canSendEmail: true,
			timeIntervalMobile: false,
			timeIntervalEmail: false,
			sendStateTextMobile: this.$t('general.send'),
			sendStateTextEmail: this.$t('general.send'),
			showCrop: false,
			showPasswordForm: false,
			cropperOption: {
				img: '',
				canMove: false,
				autoCrop: true,
				autoCropWidth: 100,
				autoCropHeight: 100,
				maxImgSize: 500,
				outputType: 'png'
			},
			member_info: {
				member_firstname: '',
				member_lastname: '',
				member_nickname: '',
				member_email: '',
				member_sex: '1',
				member_birthday: '',
				member_truename: ''
			},
			sexOption: [
				{
					label: this.$i18n.t('member.male'),
					value: '1'
				},
				{
					label: this.$i18n.t('member.female'),
					value: '2'
				}
			],
			passwordType: 'password',
			bindEmail: false,
		}
	},
	validations: {
		member_info: {
			member_sex: { required },
			member_firstname: { required, maxLength: maxLength(25) },
			member_lastname: { required, maxLength: maxLength(25) },
			member_nickname: { maxLength: maxLength(10) },
			member_email: { required, email }
		}
	},
	mounted () {
	},
	computed: {
		...mapState({
			user: state => state.member.info
		}),
		passwordFormTitle: function () {
			return this.passwordType === 'password' ? this.$i18n.t('member.modify_password') : this.$i18n.t('member.modify_payment_password')
		},
		fullName: function () {
			return this.member_info.member_firstname + '' + this.member_info.member_lastname
		}
	},
	created: function () {
		if (this.user) {
			this.member_info = this.user
			this.member_info.member_sex = String(this.member_info.member_sex)
		}
	},
	watch: {
		showEmailForm: function (value) {
			if (!value) {
				this.newEmail = ''
				this.isNewEmailDiabled = false
				this.canSendEmail = true
				this.sendStateTextEmail = this.$t('general.send')
				clearInterval(this.timeIntervalEmail)
			} else {
				this.newEmail = this.bindEmail? this.member_info.member_email : ''
			}
		}
	},
	methods: {
		...mapMutations({
			memberEdit: 'memberEdit',
			memberLogout: 'memberLogout'
		}),
		uploadImage (event) {
			let that = this
			let file = event.target.files[0]
			let reader = new FileReader()
			let rs = reader.readAsDataURL(file)
			reader.onload = (e) => {
				that.cropperOption.img = e.target.result
				let image = new Image()
				image.src = e.target.result
				image.onload = function () {
					that.cropperOption.autoCropWidth = window.screen.width
					that.cropperOption.autoCropHeight = this.height / this.width * window.screen.width
					that.cropperOption.maxImgSize = window.screen.height - 40
					that.showCrop = true
					that.$forceUpdate()
				}
			}
		},
		useCrop () {
			this.$refs.cropper.getCropBlob(res => {
				let files = new window.File([res], 'temp.png', { type: res.type })
				let formdata = new FormData()

				formdata.append('memberavatar', files)
				Indicator.open()
				uploadMemberAvatar(formdata).then(res => {
					this.user.avatar = res.result + '?' + Math.floor(Math.random() * 100)
					this.memberEdit({ member_avatar: this.user.avatar })
					this.showCrop = false
					Indicator.close()
				}).catch(function (error) {
					Toast(error.message)
					Indicator.close()
				})
			})
		},
		timeConfirm (value) {
			this.member_info.member_birthday = value.getFullYear() + '/' + (value.getMonth() + 1) + '/' + value.getDate()
		},
		onTime (picker, values) {
			this.$refs.timePicker.open()
		},
		submitInformation () {
			this.member_info.member_truename = this.fullName

			updateMemberInfo(this.member_info).then(res => {
				this.memberEdit(this.member_info)
				this.$v.$reset()
				Toast(res.message)
			}).catch(function (error) {
				Toast(error.message)
			})
		},
		displayPasswordForm (passwordType) {
			this.passwordType = passwordType
			this.showPasswordForm = true
		},
		verifySuccess () {
			if (this.authType === 'mobile') {
				this.showMobileForm = true
				this.$nextTick(function() {
					this.$refs.newMobile.focus()
				});
			} else if (this.authType === 'account') {
				MessageBox.confirm('<div style="text-align: left;">' + this.$t('member.profile.delete_account_message') + '</div>', this.$t('member.profile.delete_account_title')).then(action => {
					if (action == 'confirm') {
						deleteMember().then(res => {
							this.memberLogout()
							this.$router.push({ name: 'HomeMemberLogin' })
						}).catch(function (error) {
							Toast(error.message)
						})
					}
					this.sendAuthCode = false
				}).catch(() => {
					this.sendAuthCode = false
				})
			}
		},
		// 发送手机验证码
		sendVerifyCodeMobile () {
			if (!this.canSendMobile) {
				return
			}
			bindUserMobile(this.newMobile).then(res => {
				this.memberEdit({ member_mobile: this.newMobile, member_mobilebind: 0 })
				this.canSendMobile = false
				let second = 60
				Toast(res.message)
				let _this = this
				this.timeIntervalMobile = setInterval(function () {
					if (second <= 0) {
						_this.canSendMobile = true
						_this.sendStateTextMobile = _this.$t('general.send')
						clearInterval(_this.timeIntervalMobile)
					} else {
							_this.sendStateTextMobile = second + 's'
					}

					second--
				}, 1000)
			}).catch(function (error) {
				Toast(error.message)
			})
		},
		// 更改绑定手机号
		updateMobile () {
			updateUserMobile(this.verifyCode).then(res => {
				this.memberEdit({ member_mobile: this.newMobile, member_mobilebind: 1 })
				Toast(res.message)
				this.$router.go(0)
			}).catch(function (error) {
				Toast(error.message)
			})
		},
		// 發送信箱驗證碼
		sendVerifyCodeEmail () {
			if (!this.canSendEmail) {
				return
			}
			getEmailCode(VerifyCodeType.CHANGE, this.newEmail).then(res => {
				this.isNewEmailDiabled = true
				let seconds = 60
				Toast(res.message)
				let _this = this
				this.timeIntervalEmail = setInterval(() => {
					if (seconds <= 0) {
						_this.canSendEmail = true
						_this.sendStateTextEmail = _this.$t('general.send')
						clearInterval(_this.timeIntervalEmail)
					} else {
						_this.sendStateTextEmail = seconds + 's'
					}
					seconds--
				}, 1000)
			}).catch(function (error) {
				Toast(error.message)
			})
		},
		// 更改绑定信箱
		updateEmail () {
			checkEmailCode(this.user.member_id, VerifyCodeType.CHANGE, this.newEmail, this.verifyCode).then(res => {
				this.memberEdit({ member_email: this.newEmail, member_emailbind: 1 })
				Toast(res.message)
				this.$router.go(0)
			}).catch(function (error) {
				Toast(error.message)
			})
		},
		deleteAccount() {

		},
	}
}
</script>
<style lang="scss" scoped>
.member-information {
	background: #fff;
	padding-bottom: 1rem;
	.icon {
		margin-top: 0.5rem;
		margin-right: 1rem;
	}

	.iconfont {
		font-size: 1.5rem;
		font-weight: bold;
	}

	.user-avatar {
		position: relative;
		width: 7rem;
		height: 7rem;
		margin: 2rem auto;
		text-align: center;

		img {
			width: 100%;
			height: 100%;
			border-radius: 50%;
		}

		.upload-avatar {
			position: relative;
			top: -2rem;
			left: 6rem;

			input[type="file"] {
				display: none;
			}
		}

		.upload-avatar-button {
			top: 1rem;
			left: 0rem;
			font-size: 10px;
			width: auto;
			height: 0.9rem;
		}
	}

	.user-avatar::before {
		position: absolute;
		font-size: 1.5rem;
		line-height: 5rem;
		left: 50%;
		margin-left: -.75rem;
		color: rgba(255, 255, 255, 0.5)
	}

	.modify-password-button {
		font-size: 10px;
		width: auto;
		height: 0.9rem;
	}

	.mobile {
		text-align: center;
		margin-bottom: 1rem;
		font-size: 15px;
	}

}
.mobile-popup-content {
	position: relative;
	z-index: 100;
	padding:0 $pageSpace;
	.send-btn {
		border: 1px solid $primaryColor;
		color: $primaryColor;
		min-width: 2rem
	}
}
</style>

<style scoped>
.mint-radiolist >>> .mint-cell {
	width: 4rem;
	display: inline-block;
}

.mint-radiolist >>> .mint-cell::after {
	height: 0;
}

.mint-radiolist >>> .mint-radio-input:checked + .mint-radio-core {
	background-color: #FF9900;
	border-color: #FF9900;
}

.mint-radiolist-label {
	display: inline-block;
}
.passwordPopup {
	border-radius: 20px;
	padding: 16px 12px;
}
.passwordPopup >>> .mint-field-core {
	border: 1px solid lightgray;
	border-radius: 5px;
	padding: 2px 8px;
}
>>> .mint-cell-title {
	width: 105px;
	color: #404040;
	font-size: 0.8rem;
	flex: none;
}
>>> .mint-cell-value {
	flex: 1;
	justify-content: space-between;
}
.common-header .delete {
	color: red;
	padding-right: .5rem;
}
</style>
